import { isPlatformBrowser } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID, DOCUMENT } from '@angular/core';

/**
 * Platform-safe access to browser globals. Both tokens resolve to `null` on
 * the server so consumers degrade to anonymous/no-op behavior instead of
 * crashing during SSR.
 */
export const WINDOW = new InjectionToken<Window | null>('WINDOW', {
  providedIn: 'root',
  factory: () =>
    isPlatformBrowser(inject(PLATFORM_ID))
      ? inject(DOCUMENT).defaultView
      : null,
});

export const LOCAL_STORAGE = new InjectionToken<Storage | null>(
  'LOCAL_STORAGE',
  {
    providedIn: 'root',
    factory: () => inject(WINDOW)?.localStorage ?? null,
  },
);
